import { Component, OnDestroy, OnInit ,  VERSION} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { RefreshService } from 'src/app/refresh.service';
import { Urls } from 'src/app/lib/urls';
import { DebounceService } from 'src/app/core/services/debounce.service';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MatTooltip } from '@angular/material/tooltip';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import * as XLSX from 'xlsx';


// standalone module
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { TRANSACTION_TAB_OPTIONS } from 'src/app/lib/constants/tabs.constants';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-component.module';
import { DateInputComponent } from 'src/app/shared/component/date-input/date-input.component';
import { MegapayLoaderComponent } from 'src/app/shared/component/megapay-loader/megapay-loader.component';
import { PaginationComponent } from 'src/app/shared/component/pagination/pagination.component';
import { TableControlsComponent } from 'src/app/shared/component/table-controls/table-controls.component';
import { SharedPipeModule } from 'src/app/shared/modules/shared-pipe.module';

@Component({
  selector: 'app-store-purchase',
  templateUrl: './store-purchase.component.html',
  styleUrls: ['./store-purchase.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    DateInputComponent,
    ReactiveFormsModule,
    CommonModule,
    SharedComponentsModule,
    SharedPipeModule,
    MegapayLoaderComponent,
    NgxSpinnerModule,
    MatTooltip,
    PaginationComponent,
    TableControlsComponent,
  ],
})
export class StorePurchaseComponent implements OnInit, OnDestroy {
  tabs = TRANSACTION_TAB_OPTIONS;
  public form: UntypedFormGroup;
  private destroy$ = new Subject<void>();
  isLoading: boolean;
  isLoadingData = false;
  itemLists: any;
  search: any;
  tabId: any;
  fileName: any;
  url: any;
  showTable = true;
  params = {
    search: '',
  }

  // pagination
  page = 1;
  size = 10;
  total_pages: any;
  current_page = 1;
  pages_array = [
  ];
  total: any;
  item: any;
  lastPage: any;

  // paginationfilter
  page_filter = 1;
  size_filter = 10;
  total_pages_filter: any;
  current_page_filter = 1;
  pages_array_filter = [
  ];
  total_filter: any;
  item_filter: any;
  lastPage_filter: any;
  itemLists_filter: any;

  // paginationfilter2
  page_filter2 = 1;
  size_filter2 = 10;
  total_pages_filter2: any;
  current_page_filter2 = 1;
  pages_array_filter2 = [
  ];
  total_filter2: any;
  item_filter2: any;
  lastPage_filter2: any;
  itemLists_filter2: any;

  // search
  searchKey: any = null;
  searchForm : UntypedFormGroup;
  search_keyword = '';

  // searchfilter
  searchKey_filter: any = null;
  searchForm_filter : UntypedFormGroup;
  search_keyword_filter = '';

  // searchfilter2
  searchKey_filter2: any = null;
  searchForm_filter2 : UntypedFormGroup;
  search_keyword_filter2 = '';

  // selection viewALL or search
  option = 0
  selectedOption: any;

  // limit
  limitForm : UntypedFormGroup;

  // limitFilter
  limitForm_filter: UntypedFormGroup;

  // limitFilter
  limitForm_filter2: UntypedFormGroup;

  // null with default
  name = 'Angular ' + VERSION.major;

  // filterfields
  filterFields: any;
  filterFields2: any;

  // category
  categoryType_text: any;
  category: any;

  // sorting
  sort_column = "dateTime";
  sort_type = "ASC";

  submitted = false;

  // MAIN PAGINATION RESET
  private resetPagination(): void{  
    this.page = 1;
    this.size = 10;
    this.current_page = 1;
    this.total_pages = null;
    this.pages_array = [];
    this.total = null;
    this.item = null;
    this.lastPage = null;
  }


  // FILTER 1 RESET
  private resetFilter(): void{
    this.page_filter = 1;
    this.size_filter = 10;
    this.current_page_filter = 1;
    this.total_pages_filter = null;
    this.pages_array_filter = [];
    this.total_filter = null;
    this.item_filter = null;
    this.lastPage_filter = null;
    this.itemLists_filter = [];
  }

  // FILTER 2 RESET
  private resetFilter2(): void{
    this.page_filter2 = 1;
    this.size_filter2 = 10;
    this.current_page_filter2 = 1;
    this.total_pages_filter2 = null;
    this.pages_array_filter2 = [];
          
    this.total_filter2 = null;
    this.item_filter2 = null;
    this.lastPage_filter2 = null;
    this.itemLists_filter2 = [];
  }

  // SEARCH RESET
  private resetSearch(): void{
    this.searchForm.reset({ search: '' });
    this.search_keyword = '';
  }

  // SEARCH FILTER RESET
  private resetSearchFilter(): void{
    this.searchForm_filter.reset({ search: '' });
    this.search_keyword_filter = '';
  }

  // SEARCH 2 FILTER RESET
  private resetSearchFilter2(): void{
    this.searchForm_filter2.reset({ search: '' });
    this.search_keyword_filter2 = '';
  }

  // LIMIT RESET
  private resetLimit(): void{
    this.limitForm.reset({ limit: 10 });
  }

  // LIMIT FILTER RESET
  private resetLimitFilter(): void{
    this.limitForm_filter.reset({ limit: 10 });
  }

  // LIMIT FILTER 2 RESET
  private resetLimitFilter2(): void{
    this.limitForm_filter2.reset({ limit: 10 });
  }

  // FILTER FIELDS RESET
  private resetFilterFields(): void{  
    this.filterFields = '';
    this.filterFields2 = '';
  }

  // RESET LOCAL STORAGE
  private resetLocalStorage(): void{
    localStorage.setItem('itemLists', JSON.stringify(null));
  }

  private resetTableState(): void{
    this.resetPagination();
    this.resetFilter();
    this.resetFilter2();
    this.resetSearch();
    this.resetSearchFilter();
    this.resetSearchFilter2();
    this.resetLimit();
    this.resetLimitFilter();
    this.resetLimitFilter2();
    this.resetFilterFields();
    this.resetLocalStorage();
  }

  constructor(
    private fb : UntypedFormBuilder,
    public debounce: DebounceService,
    private request: RequestsService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private refreshService: RefreshService
  ) {  this.initializeForm();
  }

  ngOnInit(): void {
    const tableHeader = document.getElementsByTagName("th");
    for (let i = 0; i < tableHeader.length; i++) {
      tableHeader[i].classList.add("headerSortDown");
    }

    //this.get_List();

    this.refreshService.resetTable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.form.reset({search: ''}); //reset filter fields
      this.resetTableState(); //reset filters, pagination, entries, etc.
      this.itemLists = null; // clear table

      //Hide Table
      this.showTable = false;

    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    
    this.spinner.hide().catch((err) => {
      console.error('Spinner hide error on destroy:', err);
    });
  }

  initializeForm() {
    this.form = this.fb.group({
      transactionId: [null],
      phoneNumber: [null],
      productName: [null],
      firstName: [null],
      middleName: [null],
      lastName: [null],
      dateFrom: [null],
      dateTo: [null],
    });

    this.searchForm = this.fb.group({ search: [''] });
    this.searchForm_filter = this.fb.group({ search: [''] });
    this.searchForm_filter2 = this.fb.group({ search: [''] });
    this.limitForm = this.fb.group({ limit: [10] });
    this.limitForm_filter = this.fb.group({ limit: [10] });
    this.limitForm_filter2 = this.fb.group({ limit: [10] });

    this.searchKey = this.debounce.debounce(() => {
      this.current_page = 1;
      this.get_List();
    }, 500);

    this.searchKey_filter = this.debounce.debounce(() => {
      this.current_page_filter = 1;
      this.get_search_list();
    }, 500);

    this.searchKey_filter2 = this.debounce.debounce(() => {
      this.current_page_filter2 = 1;
      this.get_search_list2();
    }, 500);
  }

submit(){
  if (this.form.valid){
    this.submitted = true;
    this.isLoadingData = true;
    this.searchForm_filter.reset();
    this.searchForm_filter2.reset();
    this.search_keyword_filter = null;
    this.search_keyword_filter2 = null;
    if (this.itemLists_filter2){
      this.itemLists = null;
      this.itemLists_filter2 = null;
      this.current_page_filter2 = 1;
      this.getSearch2();
    } else {
      this.itemLists = null;
      this.itemLists_filter = null;
      this.current_page_filter = 1;
      this.getSearch();
    }
    this.showTable = true;
  }
}
sortList(sort_column, sort_type){
  this.spinner.show();
  if (sort_type == "ASC" && this.sort_column != sort_column && this.sort_type == sort_type){
    this.sort_type = "DESC";
    this.sort_column = sort_column;
  }else if (sort_type == "ASC" && this.sort_column == sort_column && this.sort_type != sort_type){
    this.sort_type = "ASC";
    this.sort_column = sort_column;
  }else if (sort_type == "ASC" && this.sort_column == sort_column && this.sort_type == sort_type){
    this.sort_type = "DESC";
    this.sort_column = sort_column;
  }else if (sort_type == "DESC" && this.sort_column != sort_column && this.sort_type == sort_type){
    this.sort_type = "DESC";
    this.sort_column = sort_column;
  }else if (sort_type == "DESC" && this.sort_column == sort_column && this.sort_type != sort_type){
    this.sort_type = "DESC";
    this.sort_column = sort_column;
  }else if (sort_type == "DESC" && this.sort_column == sort_column && this.sort_type == sort_type){
    this.sort_type = "ASC";
    this.sort_column = sort_column;
  }
  if (this.itemLists){
    this.get_List();
  }else if (this.itemLists_filter){
    this.itemLists = null;
    this.current_page_filter = 1;
    this.get_search_list()
  }else if (this.itemLists_filter2){
    this.itemLists = null;
    this.current_page_filter2 = 1;
    this.get_search_list2();
  }
  console.log('sort_column', this.sort_column);
  console.log('sort_type', this.sort_type);
}

  get activeList() {
    if (this.itemLists_filter2) return this.itemLists_filter2;
    if (this.itemLists_filter)  return this.itemLists_filter;
    return this.itemLists;
  }

  get activeLimit() {
    if (this.itemLists_filter2) return {
      size:          this.size_filter2,
      total:         this.total_filter2 ?? 0,
      onLimitChange: (e: any) => this.onLimitChange_filter2(e),
    };
    if (this.itemLists_filter) return {
      size:          this.size_filter,
      total:         this.total_filter ?? 0,
      onLimitChange: (e: any) => this.onLimitChange_filter(e),
    };
    return {
      size:          this.size ?? 10,
      total:         this.total ?? 0,
      onLimitChange: (e: any) => this.onLimitChange(e),
    };
  }

  get activeSearch() {
    if (this.itemLists_filter2) return {
      onSearchKeyup: (e: any) => this.onSearchKeyup_filter2(e),
    };
    if (this.itemLists_filter) return {
      onSearchKeyup: (e: any) => this.onSearchKeyup_filter(e),
    };
    return {
      onSearchKeyup: (e: any) => this.onSearchKeyup(e),
    };
  }

  get activePage() {
    if (this.itemLists_filter2) return {
      current: this.current_page_filter2 ?? 1,
      total:   this.total_pages_filter2 ?? 1,
    };
    if (this.itemLists_filter) return {
      current: this.current_page_filter ?? 1,
      total:   this.total_pages_filter ?? 1,
    };
    return {
      current: this.current_page ?? 1,
      total:   this.total_pages ?? 1,
    };
  }


  onLimitChange(event: any): void {
    const value = parseInt(event.target.value);
    this.size = (!value || isNaN(value)) ? 10 : value;
    this.current_page = 1;
    this.get_List();
  }

  onLimitChange_filter(event: any): void {
    const value = parseInt(event.target.value);
    this.size_filter = (!value || isNaN(value)) ? 10 : value;
    this.current_page_filter = 1;
    this.get_search_list();
  }

  onLimitChange_filter2(event: any): void {
    const value = parseInt(event.target.value);
    this.size_filter2 = (!value || isNaN(value)) ? 10 : value;
    this.current_page_filter2 = 1;
    this.get_search_list2();
  }

  onSearchKeyup(event: any): void {
    this.search_keyword = event.target.value;
    this.current_page = 1;
    this.searchKey();
  }

  onSearchKeyup_filter(event: any): void {
    this.search_keyword_filter = event.target.value;
    this.current_page_filter = 1;
    this.searchKey_filter();
  }

  onSearchKeyup_filter2(event: any): void {
    this.search_keyword_filter2 = event.target.value;
    this.current_page_filter2 = 1;
    this.searchKey_filter2();
  }

getSearch(){
  this.option = 2
  this.spinner.show();
  const params = {
    transactionId: this.form.controls.transactionId.value,
    phoneNumber: this.form.controls.phoneNumber.value,
    productName: this.form.controls.productName.value,
    firstName: this.form.controls.firstName.value,
    middleName: this.form.controls.middleName.value,
    lastName: this.form.controls.lastName.value,
    dateFrom: this.form.controls.dateFrom.value,
    dateTo: this.form.controls.dateTo.value,
    category: this.category,
    sortBy: {
      [this.sort_column]: this.sort_type
    }
  }
  localStorage.setItem('itemLists', JSON.stringify(params));
  this.pages_array_filter = [];
  this.request.post(Urls.transactionsPurchases + '?page=' + this.current_page_filter + '&size=' + this.size_filter, params).then(response => {
    if (response.status == 200){
      this.itemLists_filter = response.result.data;
      this.filterFields = response.result.filterFields
      this.selectedOption = "getSearch";
        if (this.current_page_filter  === 0  ){
          this.pages_array_filter = [];
          for (let i = this.current_page_filter; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else if (this.current_page_filter == 1){
          for (let i = 1; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else if (this.current_page_filter == response.result.totalPages){
          for (let i = this.current_page_filter - 2; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else{
          for (let i = this.current_page_filter - 1; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }
        this.total_pages_filter = parseInt(response.result.totalPages);
        this.current_page_filter = response.result.currentPage;
        this.total_filter = parseInt(response.result.totalItems);
        this.form.reset();          
        this.category = null; 
        this.categoryType_text = null;
        setTimeout(() => {
          this.spinner.hide();
        }, 500);
      }
    }).finally(() => {
      this.isLoadingData = false;
  });
}

get_search_list(){
  this.option = 2
  this.spinner.show();
  const params = {
    transactionId: this.filterFields.transactionId,
    phoneNumber: this.filterFields.phoneNumber,
    productName: this.filterFields.productName,
    firstName: this.filterFields.firstName,
    middleName: this.filterFields.middleName,
    lastName: this.filterFields.lastName,
    dateFrom: this.filterFields.dateFrom,
    dateTo: this.filterFields.dateTo,
    category: this.filterFields.category,
    search: this.search_keyword_filter,
    sortBy: {
      [this.sort_column]: this.sort_type
    }
  }
  localStorage.setItem('itemLists', JSON.stringify(params));
  this.pages_array_filter = [];
  this.request.post(Urls.transactionsPurchases + '?page=' + this.current_page_filter + '&size=' + this.size_filter, params).then(response => {
    if (response.status == 200){
      this.itemLists_filter = response.result.data;
      this.filterFields = response.result.filterFields
      this.selectedOption = "getSearch";
        if (this.current_page_filter  === 0  ){
          this.pages_array_filter = [];
          for (let i = this.current_page_filter; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else if (this.current_page_filter == 1){
          for (let i = 1; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else if (this.current_page_filter == response.result.totalPages){
          for (let i = this.current_page_filter - 2; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }else{
          for (let i = this.current_page_filter - 1; i <= response.result.totalPages; i++){
            this.pages_array_filter.push(i);
          };
        }
        this.total_pages_filter = parseInt(response.result.totalPages);
        this.current_page_filter = response.result.currentPage;
        this.total_filter = parseInt(response.result.totalItems);
        setTimeout(() => {
          this.spinner.hide();
        }, 500);
     }
   }).finally(() => {
  });
}

getSearch2(){
  this.option = 3
  this.spinner.show();
  const params = {
    transactionId: this.form.controls.transactionId.value,
    phoneNumber: this.form.controls.phoneNumber.value,
    productName: this.form.controls.productName.value,
    firstName: this.form.controls.firstName.value,
    middleName: this.form.controls.middleName.value,
    lastName: this.form.controls.lastName.value,
    dateFrom: this.form.controls.dateFrom.value,
    dateTo: this.form.controls.dateTo.value,
    category: this.category,
    sortBy: {
      [this.sort_column]: this.sort_type
    }
  }
  localStorage.setItem('itemLists', JSON.stringify(params));
  this.pages_array_filter2 = [];
  this.request.post(Urls.transactionsPurchases + '?page=' + this.current_page_filter2 + '&size=' + this.size_filter2, params).then(response => {
    if (response.status == 200){
      this.itemLists_filter2 = response.result.data;
      this.filterFields2 = response.result.filterFields
      this.selectedOption = "getSearch2";
        if (this.current_page_filter2  === 0  ){
          this.pages_array_filter2 = [];
          for (let i = this.current_page_filter2; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else if (this.current_page_filter2 == 1){
          for (let i = 1; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else if (this.current_page_filter2 == response.result.totalPages){
          for (let i = this.current_page_filter2 - 2; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else{
          for (let i = this.current_page_filter2 - 1; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }
        this.total_pages_filter2 = parseInt(response.result.totalPages);
        this.current_page_filter2 = response.result.currentPage;
        this.total_filter2 = parseInt(response.result.totalItems);
        this.form.reset();           
        this.category = null;
        this.categoryType_text = null;
        setTimeout(() => {
          this.spinner.hide();
        }, 500);
      }
    }).finally(() => {
  });
}

get_search_list2(){
  this.option = 3
  this.spinner.show();
  const params = {
    transactionId: this.filterFields2.transactionId,
    phoneNumber: this.filterFields2.phoneNumber,
    productName: this.filterFields2.productName,
    firstName: this.filterFields2.firstName,
    middleName: this.filterFields2.middleName,
    lastName: this.filterFields2.lastName,
    dateFrom: this.filterFields2.dateFrom,
    dateTo: this.filterFields2.dateTo,
    category: this.filterFields2.category,
    search: this.search_keyword_filter2,
    sortBy: {
      [this.sort_column]: this.sort_type
    }
  }
  localStorage.setItem('itemLists', JSON.stringify(params));
  this.pages_array_filter2 = [];
  this.request.post(Urls.transactionsPurchases + '?page=' + this.current_page_filter2 + '&size=' + this.size_filter2, params).then(response => {
    if (response.status == 200){
      this.itemLists_filter2 = response.result.data;
      this.filterFields2 = response.result.filterFields
      this.selectedOption = "getSearch2";
        if (this.current_page_filter2  === 0  ){
          this.pages_array_filter2 = [];
          for (let i = this.current_page_filter2; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else if (this.current_page_filter2 == 1){
          for (let i = 1; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else if (this.current_page_filter2 == response.result.totalPages){
          for (let i = this.current_page_filter2 - 2; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }else{
          for (let i = this.current_page_filter2 - 1; i <= response.result.totalPages; i++){
            this.pages_array_filter2.push(i);
          };
        }
        this.total_pages_filter2 = parseInt(response.result.totalPages);
        this.current_page_filter2 = response.result.currentPage;
        this.total_filter2 = parseInt(response.result.totalItems);
        setTimeout(() => {
          this.spinner.hide();
        }, 500);
      }
    }).finally(() => {
  });
}

get_List(){
  this.option = 1
  this.spinner.show();
  const params = {
    search : this.search_keyword,
    sortBy: {
      [this.sort_column]: this.sort_type
    }
  }
  localStorage.setItem('itemLists', JSON.stringify(params));
  this.pages_array = [];
  this.request.post(Urls.transactionsPurchases + '?page=' + this.current_page + '&size=' + this.size, params).then(response => {
    this.itemLists = response.result.data;
    if (response.status == 200){
        if (this.current_page  === 0  ){
          this.pages_array = [];
          for (let i = this.current_page; i <= response.result.totalPages; i++){
            this.pages_array.push(i);
          };
        }else if (this.current_page == 1){
          for (let i = 1; i <= response.result.totalPages; i++){
            this.pages_array.push(i);
          };
        }else if (this.current_page == response.result.totalPages){
          for (let i = this.current_page - 2; i <= response.result.totalPages; i++){
            this.pages_array.push(i);
          };
        }else{
          for (let i = this.current_page - 1; i <= response.result.totalPages; i++){
            this.pages_array.push(i);
          };
        }
        this.total_pages = parseInt(response.result.totalPages);
        this.current_page = response.result.currentPage;
        this.total = parseInt(response.result.totalItems);
        setTimeout(() => {
          this.spinner.hide();
        }, 500);
      }
    }).finally(() => {
  });
}


setPage(num){
  if (this.option == 1){
    // TOTAL PAGE USE THIS
    console.log("option is 1 : viewALL")
    this.current_page = num;
    this.get_List();
  }else if (this.option == 2){
    // TOTAL PAGE USE THIS
    console.log("option is 2 : searchFILTER")
    this.current_page_filter = num;
    this.get_search_list()
  }else if (this.option == 3){
    // TOTAL PAGE USE THIS
    console.log("option is 3 : searchFILTER2")
    this.current_page_filter2 = num;
    this.get_search_list2()
  }
}

nextPage(){
  if (this.option == 1){
    // TOTAL PAGE USE THIS
    console.log("option is 1 : viewALL")
    if (this.current_page < Number(this.total_pages)){
      this.current_page++;
      this.get_List()
    }
  }
  else if (this.option == 2){
    // FILTER PAGE USE NEXT FILTER
    console.log("option is 2 : searchFILTER")
    if (this.current_page_filter < Number(this.total_pages_filter)){
      this.current_page_filter++;
      this.get_search_list()
    }
  } else if (this.option == 3){
    // FILTER PAGE USE NEXT FILTER
    console.log("option is 3 : searchFILTER2")
    if (this.current_page_filter2 < Number(this.total_pages_filter2)){
      this.current_page_filter2++;
      this.get_search_list2()
    }
  }
}

prevPage(){
  console.log("prevPage")
  if (this.option == 1){
    if (this.current_page > 1){
      this.current_page--;
      this.get_List();
    }
  }
  else if (this.option == 2){
    if (this.current_page_filter > 1){
      this.current_page_filter--;
      this.get_search_list();
    }
  }
  else if (this.option == 3){
    if (this.current_page_filter2 > 1){
      this.current_page_filter2--;
      this.get_search_list2();
    }
  }
}

keyDownFunction(event) {
  if (event.keyCode === 13) {
    this.searchList();
  }
}

searchList(){
  if (this.option === 1){
    this.current_page = 1;
    this.search_keyword = this.searchForm.value.search;
    console.log('searchKeyword', this.search_keyword)
    this.get_List();
  }else if (this.option === 2){
    this.current_page_filter = 1;
    this.search_keyword_filter = this.searchForm_filter.value.search;
    console.log('searchKeyword', this.search_keyword_filter)
    this.get_search_list();
  }
  else if (this.option === 3){
    this.current_page_filter2 = 1;
    this.search_keyword_filter2 = this.searchForm_filter2.value.search;
    console.log('searchKeyword', this.search_keyword_filter2)
    this.get_search_list2();
  }
}

setheader(index){
  localStorage.setItem('navigate', index);
}

setCategoryType(text, value){
  this.category = value;
  this.categoryType_text = text;
}
async print(){
  this.spinner.show().catch(error => { console.log(error); });
  const current = new Date();
  this.params = JSON.parse(localStorage.getItem('itemLists'));
  this.fileName = current.toLocaleDateString() + "-store-purchase.xlsx";

  try {
    const requestBlob = await this.request.postBlob(Urls.exportTransactionsPurchases, this.params).then(report => {
      const blob = new Blob([report], { type: 'application/vnd.ms-excel' });
      const data = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = data;
      link.download = this.fileName;
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });
    this.spinner.hide().catch(error => { console.log(error); });
  } catch (error) {
    this.spinner.hide().catch(err => { console.log(err); });
  }
}

}
